var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.36377C13.0043 5.4364 13.5944 6.07103 13.5947 6.84424V12.105C13.5947 12.9272 12.9277 13.5942 12.1055 13.5942H6.84668C6.07347 13.5942 5.43913 13.0046 5.36621 12.2505H6.59766C6.64783 12.3363 6.74026 12.394 6.84668 12.394H12.1055C12.265 12.394 12.3945 12.2645 12.3945 12.105V6.84424C12.3943 6.73775 12.336 6.64524 12.25 6.59521V5.36377Z",
    fill: "#002A69"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#002A69",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.e0f94394802784eee7d35aad24c51b55.svg";
export { ForwardRef as ReactComponent };